import React, { useEffect, useState } from 'react';
import SearchPromptContents from './SearchPromptContents';
import SearchPromptInput from './SearchPromptInput';
import { StyleProp, ViewStyle } from 'react-native';

export type SearchBarOwnProps = {
    medicalProfileId: string;
    style?: StyleProp<ViewStyle>;
};

export type SearchBarProps = SearchBarOwnProps;

const SearchBar: React.FC<SearchBarProps> = ({ medicalProfileId, style }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [remountKey, setRemountKey] = useState(0);
    useEffect(() => {
        if (!isOpen) {
            const timeout = setTimeout(() => setRemountKey((prev) => prev + 1), 300);
            return () => clearTimeout(timeout);
        }
    }, [isOpen]);

    return (
        <>
            <SearchPromptInput onFocus={() => setIsOpen(true)} style={style} />
            <SearchPromptContents
                key={remountKey}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                medicalProfileId={medicalProfileId}
            />
        </>
    );
};

export default React.memo(SearchBar);
